<mat-card class="w-full">
  <mat-card-content class="flex justify-center items-center w-full">
    <div class="flex flex-col w-full" style="overflow-x:auto;">
      <div class="flex flex-row w-full">

        <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort" class="w-full">

          <ng-container matColumnDef="businessName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Name</th>
            <td mat-cell *matCellDef="let complaint">
              <a (click)="gotoBusiness(complaint.id)">{{complaint.businessName}}</a>
            </td>
          </ng-container>
          <ng-container matColumnDef="businessAddress">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
            <td mat-cell *matCellDef="let complaint">{{complaint.businessAddress}}</td>
          </ng-container>
          <ng-container matColumnDef="businessCity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
            <td mat-cell *matCellDef="let complaint">{{complaint.businessCity}}</td>
          </ng-container>
          <ng-container matColumnDef="businessZip">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Zip Code</th>
            <td mat-cell *matCellDef="let complaint">{{complaint.businessZip}}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

        </table>
      </div>
      <mat-paginator [pageSizeOptions]="[5, 20, 100]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
    </div>

  </mat-card-content>
</mat-card> 
